module.exports = __webpack_public_path__ + "media/images/home/coachs-0fe05dd93b6fbada9e4e2ecee2ce4b64.jpg";